import React, { FC } from "react"
import { useToggle } from "../../utils/Hooks"
import { ArrowLink } from "../views/atoms/links/ArrowLink"
import { Modal as ModalTemplate } from "../views/modal/Modal"
import { Contents } from "./Contents"
import styled from "styled-components"
import { Spacer } from "../views/atoms/Atoms"
import { IModal } from "contentful-types"
import { DynamicContentComponentProps } from "./DynamicContentComponentProps"
import { H2Library } from "@carrotfertility/carotene"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 504px;
  height: 562px;
  margin-left: 48px;
  margin-bottom: 62px;
`

export const Modal: FC<DynamicContentComponentProps<IModal>> = ({ content }) => {
  const {
    fields: { linkText, content: internalContent, title }
  } = content

  const [showModal, toggleShowModal] = useToggle(false)

  return (
    <>
      <ArrowLink onClick={toggleShowModal}>{linkText}</ArrowLink>
      {showModal && (
        <ModalTemplate onExit={toggleShowModal} titleText={title}>
          <Wrapper>
            <H2Library variant="dark">{title}</H2Library>
            <Spacer height={2}></Spacer>
            <Contents contents={internalContent} />
          </Wrapper>
        </ModalTemplate>
      )}
    </>
  )
}
